import type { QuizCreateSchema } from '@repo/schemas/quiz/quizBuilder';

import { useMutation } from '@tanstack/react-query';

import { QuizService } from './quizService';

export function useCreateQuiz() {
  return useMutation({
    mutationFn: (data: QuizCreateSchema) => QuizService.createQuiz(data).then((response) => response.data),
  });
}
